import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement, useState } from 'react';
import { HeaderWithDescription } from '../../../../modules/common/headerWithDescription/HeaderWithDescription';
import { SpaceBetweenLayout } from '../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { RegisterUserContainer } from '../containers/RegisterUserContainer';

export const AdminHeader = (): ReactElement => {
  const { t } = useTranslator();

  const [showCreateNewUser, setShowCreateNewUser] = useState(false);

  return (
    <SpaceBetweenLayout>
      <HeaderWithDescription header={t('admin_panel')} />
      <Button
        onClick={() => {
          setShowCreateNewUser(!showCreateNewUser);
        }}
      >
        {t('new_user')}
      </Button>
      <RegisterUserContainer
        showModal={showCreateNewUser}
        onClose={() => {
          setShowCreateNewUser(false);
        }}
      />
    </SpaceBetweenLayout>
  );
};
